export default __webpack_public_path__ + "static/media/Beast Hunter's Mantle of the Living Legend.e5166e1d.jpg";